import React from "react";
import { useLang } from "../i18n/LanguageContext";
import { Hammer, Square, Paintbrush, Ruler, LayoutGrid, Grid3x3, Home } from "lucide-react";

const ICONS = [Hammer, Square, Paintbrush, Ruler, LayoutGrid, Grid3x3, Home];

export default function Services() {
  const { t } = useLang();

  return (
    <section id="services" data-testid="services-section" className="relative bg-black py-24 sm:py-32 border-t border-neutral-900">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-8 mb-14">
          <div className="lg:col-span-7">
            <div className="flex items-center gap-3 text-orange-500 font-mono-label text-xs uppercase tracking-[0.25em] mb-5">
              <span className="w-8 h-px bg-orange-500" /> {t.services.label}
            </div>
            <h2 className="font-display uppercase text-white text-4xl sm:text-5xl lg:text-6xl leading-[0.95] whitespace-pre-line">
              {t.services.title}
            </h2>
          </div>
          <div className="lg:col-span-5 flex items-end">
            <p className="text-neutral-400 text-base sm:text-lg leading-relaxed">
              From the studs to the finish coat — every trade we offer is handled in-house by experienced craftsmen.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-neutral-900 border border-neutral-900">
          {t.services.items.map((s, i) => {
            const Icon = ICONS[i] || Hammer;
            return (
              <div
                key={i}
                data-testid={`service-card-${i}`}
                className="service-card group relative bg-neutral-950 hover:bg-neutral-900 p-8 sm:p-10 transition-colors cursor-default"
              >
                <div className="flex items-center justify-between mb-8">
                  <span className="font-mono-label text-xs text-neutral-600 uppercase tracking-[0.2em]">
                    0{i + 1}
                  </span>
                  <div className="service-icon w-12 h-12 grid place-items-center bg-neutral-900 group-hover:bg-orange-500 text-orange-500 group-hover:text-black rounded-sm transition-colors">
                    <Icon size={22} />
                  </div>
                </div>
                <h3 className="font-display uppercase text-white text-2xl sm:text-3xl leading-tight mb-3">
                  {s.name}
                </h3>
                <p className="text-neutral-400 text-sm leading-relaxed">{s.desc}</p>
                <div className="absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-orange-500 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
              </div>
            );
          })}
          <div className="bg-orange-500 p-8 sm:p-10 flex flex-col justify-between group hover:bg-orange-600 transition-colors">
            <div className="font-mono-label text-xs text-black/70 uppercase tracking-[0.2em]">06+</div>
            <div>
              <div className="font-display uppercase text-black text-2xl sm:text-3xl leading-tight mb-2">
                Need something else?
              </div>
              <p className="text-black/80 text-sm">Ask us — we handle a range of commercial and residential work.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
